import React from "react";

function Scheduled() {
  return (
    <div className="shadow rounded-bottom text-black">
      <div style={{ background: "#F9FAFD" }} className="d-flex p-3 rounded-top fw-bold">
        <span className="flex-1">Tags</span>
        <span className="flex-1">Total</span>
        <span className="flex-1">Booked</span>
        <span className="flex-1">Done</span>
      </div>
      <div className="p-3 rounded-bottom">
        No Data
      </div>
    </div>
  );
}

export default Scheduled;
